module.exports = __webpack_public_path__ + "img/MenuButton_VIC.540ab482.png";